// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"index--checkbox--3PU30","checkbox--selected":"index--checkbox--selected--13nzF","checkbox__icon":"index--checkbox__icon--1ZXEj"};